var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsappIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8.33333C7.5 8.44384 7.5439 8.54982 7.62204 8.62796C7.70018 8.7061 7.80616 8.75 7.91667 8.75C8.02717 8.75 8.13315 8.7061 8.21129 8.62796C8.28943 8.54982 8.33333 8.44384 8.33333 8.33333V7.5C8.33333 7.38949 8.28943 7.28351 8.21129 7.20537C8.13315 7.12723 8.02717 7.08333 7.91667 7.08333C7.80616 7.08333 7.70018 7.12723 7.62204 7.20537C7.5439 7.28351 7.5 7.38949 7.5 7.5V8.33333ZM7.5 8.33333C7.5 9.4384 7.93899 10.4982 8.72039 11.2796C9.50179 12.061 10.5616 12.5 11.6667 12.5M11.6667 12.5H12.5C12.6105 12.5 12.7165 12.4561 12.7946 12.378C12.8728 12.2998 12.9167 12.1938 12.9167 12.0833C12.9167 11.9728 12.8728 11.8668 12.7946 11.7887C12.7165 11.7106 12.6105 11.6667 12.5 11.6667H11.6667C11.5562 11.6667 11.4502 11.7106 11.372 11.7887C11.2939 11.8668 11.25 11.9728 11.25 12.0833C11.25 12.1938 11.2939 12.2998 11.372 12.378C11.4502 12.4561 11.5562 12.5 11.6667 12.5ZM2.5 17.5L3.875 14.3333C2.82305 12.84 2.35222 11.0142 2.55087 9.1984C2.74952 7.38262 3.60399 5.70176 4.95392 4.47124C6.30386 3.24073 8.05646 2.54515 9.88282 2.51506C11.7092 2.48496 13.4837 3.12241 14.8735 4.30778C16.2632 5.49316 17.1726 7.14496 17.431 8.9532C17.6893 10.7614 17.2789 12.6018 16.2768 14.1289C15.2746 15.6561 13.7495 16.765 11.9878 17.2476C10.2261 17.7301 8.34885 17.5532 6.70833 16.75L2.5 17.5Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/WhatsappIcon.a1b14c4f66b5701ffe5479d793cc035d.svg";
export { ForwardRef as ReactComponent };